import { PayloadAction } from '@reduxjs/toolkit';
import { IContentsData } from '@/store/types';
import { createSliceSteamup } from '../common';

interface IContentsState {
  loading: boolean;
  list: IContentsData[];

  filter: {
    keyword: number[];
    q: string;
  }
}

const contentsSlice = createSliceSteamup(
  'contents',
  {
    loading: true,
    list: [],
    filter: {
      keyword: [],
      q: '',
    },
  } as IContentsState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.list)>) {
      state.list = payload;
    },
    setKeyword(state, { payload }: PayloadAction<(typeof state.filter.keyword)>) {
      state.filter.keyword = payload;
    },
    setQ(state, { payload }: PayloadAction<(typeof state.filter.q)>) {
      state.filter.q = payload;
    },
    setRemoveKeyword(state) {
      state.filter.q = '';
    },
    setReset(state) {
      state.filter.q = '';
      state.filter.keyword = [];
    },
    pushFilterOfTag(state, { payload }: PayloadAction<number>) {
      state.filter.keyword.push(payload);
    },
    setFilterOfTag(state, { payload }: PayloadAction<{ keyIDs: number[] }>) {
      state.filter.keyword = payload.keyIDs;
    },
    setRemoveTag(state, { payload }: PayloadAction<number>) {
      state.filter.keyword = state.filter.keyword.filter((id) => id !== payload);
    },
  },
);

export default contentsSlice;
